import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftActionsButtons,
  CftTank,
  CftHeaderSteps,
  CftLeavingModal,
  CftExportData,
} from "../../components";
import routes from "../../utils/cftRoutes";
import { PigsHerdFeedsForm } from "../../forms/pigs";
import useCftPigsValues, { PIGS_TABS } from "../../utils/useCftPigsValues";
import "../styles/progressDashboard.scss";

export default function PigsHerdFeedsPage() {
  const { t } = useTranslation(["cftTurkey", "cftChickenBroiler", "cftPigs"]);
  const history = useHistory();
  const { store } = useCftPigsValues();
  const [showLeavingModal, setShowLeavingModal] = useState(false);
  const stopOverflow = () => {
    document.querySelector("body").style.overflowY = "hidden";
    document.querySelector("html").style.overflow = "hidden";
  };

  return (
    <CftLayout
      header={
        <CftHeader
          cropName={t("cftPigs:tag", "Trzoda chlewna")}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportData type="pigs" />
              <CftActionsButtons.CancelButton
                hasText={false}
                onClick={() => {
                  stopOverflow();
                  setShowLeavingModal(!showLeavingModal);
                }}
              />
            </CftTank>
          }
        />
      }
    >
      <CftSection
        withNoSpace
        header={
          <CftTank display="flex" flexDirection="column" alignItems="center">
            <h3 className="cft-wrapper">
              {t("cftPigs:title", "kalkulator emisji")}
            </h3>
            <h4 className="cft-wrapper">
              {t("cftPigs:tag", "Trzoda chlewna")}
            </h4>
            <CftHeaderSteps store={store} tabs={PIGS_TABS} />
          </CftTank>
        }
      >
        <PigsHerdFeedsForm />
      </CftSection>
      <CftLeavingModal
        isVisible={showLeavingModal}
        hide={() => setShowLeavingModal(!showLeavingModal)}
        type="bothCalc"
        goToProfile={() => history.push(routes.MAIN)}
        dataReport={JSON.stringify(store)}
      />
    </CftLayout>
  );
}
